var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFieldDatatypeId = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 0h17a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m3.486 9.902V11h4.428V9.902h-1.602V5.798h1.602V4.7H7.486v1.098h1.593v4.104zM12.85 4.7v6.309q.117.019.333.031.216.014.45.027a19 19 0 0 0 .828.032q.908 0 1.49-.283a2.35 2.35 0 0 0 .908-.748 2.8 2.8 0 0 0 .455-1.057 6 6 0 0 0 .126-1.215q0-.684-.126-1.264a2.6 2.6 0 0 0-.446-1.008A2.14 2.14 0 0 0 16 4.853q-.549-.243-1.386-.243a27 27 0 0 0-1.022.031 13 13 0 0 0-.742.059m1.809 1.008q.513 0 .81.198t.446.504q.148.306.188.675a6.5 6.5 0 0 1-.004 1.503q-.045.396-.198.711t-.463.509q-.311.193-.833.193l-.414-.022a1 1 0 0 1-.108-.014V5.744l.243-.023a4 4 0 0 1 .333-.013"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFieldDatatypeId);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/field-datatype-id.8ac9f08a.svg";